var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideosDark = function SvgVideosDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.903 7.109a.23.23 0 01-.224-.227 1.974 1.974 0 01.843-1.588c.34-.308.635-.573.63-1.068a.22.22 0 01.38-.16.23.23 0 01.066.16 1.798 1.798 0 01-.778 1.411c-.377.34-.702.634-.696 1.245a.222.222 0 01-.22.227z",
    fill: "url(#VideosDark_svg__qgj8vm3z4a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.186 8.78l-.098-.235a2.843 2.843 0 00-2.71-2.104l-8.882-.02a2.753 2.753 0 00-2.619 1.914c-.055.132-.109.268-.165.407a16.363 16.363 0 00-.664 6.732 1.562 1.562 0 001.14 1.502 1.479 1.479 0 001.696-.734c.23-.365 1.075-1.575 1.904-2.895.26.143.55.218.847.22 1.476.003 1.48-1.193 2.43-1.19a.41.41 0 01.138 0c.95.003.975 1.2 2.451 1.203.216 0 .43-.039.63-.116.84 1.285 1.676 2.45 1.906 2.807a1.504 1.504 0 002.821-.757 16.48 16.48 0 00-.825-6.735z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.682 9.393a2.311 2.311 0 01-2.295 2.36 2.377 2.377 0 01-2.339-2.373 2.312 2.312 0 012.294-2.36 2.377 2.377 0 012.34 2.373zM5.668 6.996a2.311 2.311 0 00-2.295 2.36 2.377 2.377 0 002.339 2.372 2.311 2.311 0 002.294-2.36 2.377 2.377 0 00-2.338-2.372z",
    fill: "#132028"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 11.199a.624.624 0 00.43-.77.624.624 0 00-.757-.45.624.624 0 00-.431.77c.09.336.43.538.758.45z",
    fill: "url(#VideosDark_svg__ydniadgkhb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.56 8.841a.624.624 0 00.431-.769.624.624 0 00-.758-.45.624.624 0 00-.43.769c.09.337.429.538.757.45z",
    fill: "url(#VideosDark_svg__18wvau6bfc)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.416 10.018a.624.624 0 00.43-.77.624.624 0 00-.757-.45.624.624 0 00-.431.77c.09.336.43.538.758.45z",
    fill: "url(#VideosDark_svg__6rf6kr084d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.724 10.024a.624.624 0 00.431-.77.624.624 0 00-.758-.45.624.624 0 00-.43.77c.09.336.429.538.757.45z",
    fill: "url(#VideosDark_svg__u6ah8yd1re)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.467 10.476l-.767-.003a.247.247 0 01-.243-.247.24.24 0 01.239-.245l.766.003a.247.247 0 01.243.247.24.24 0 01-.238.245zm2.233-.24a.247.247 0 00-.243-.245l-.767-.003a.24.24 0 00-.238.245.247.247 0 00.243.247l.766.003a.24.24 0 00.239-.245v-.001zm-4.089.403A1.068 1.068 0 006.55 11.73a1.1 1.1 0 001.082 1.098 1.066 1.066 0 001.061-1.091 1.1 1.1 0 00-1.082-1.098zm4.79.013a1.068 1.068 0 00-1.062 1.091 1.1 1.1 0 001.082 1.098 1.069 1.069 0 001.062-1.092 1.099 1.099 0 00-1.083-1.097zM4.818 8.79l-.835-.002c-.096-.001-.175.108-.174.243l.005.598a.222.222 0 00.177.24l.835.002a.15.15 0 00.116-.06l.244-.298a.31.31 0 00-.003-.367l-.252-.295a.154.154 0 00-.117-.06l.004-.001zm1.396-.279l-.007-.853c0-.095-.109-.18-.24-.18h-.59a.212.212 0 00-.24.18l.008.852a.16.16 0 00.06.119l.296.252a.292.292 0 00.358 0l.29-.252a.155.155 0 00.059-.118h.006zm.35 1.419l.835.002c.096 0 .175-.108.174-.243L7.57 9.09a.222.222 0 00-.177-.24l-.84-.005a.15.15 0 00-.115.06L6.19 9.2a.31.31 0 00.003.367l.25.3a.154.154 0 00.113.065l.008-.002zm-1.396.278l.007.853c0 .096.109.18.24.18l.586.002a.212.212 0 00.24-.18l-.008-.852a.16.16 0 00-.061-.119l-.296-.253a.292.292 0 00-.357 0l-.29.253a.156.156 0 00-.064.117h.003z",
    fill: "url(#VideosDark_svg__ctmb3zk92f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "VideosDark_svg__ydniadgkhb",
    x1: 13.768,
    y1: 11.664,
    x2: 14.957,
    y2: 11.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VideosDark_svg__18wvau6bfc",
    x1: 14.207,
    y1: 9.354,
    x2: 15.395,
    y2: 9.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDA83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VideosDark_svg__6rf6kr084d",
    x1: 12.854,
    y1: 10.27,
    x2: 14.041,
    y2: 9.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E61739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VideosDark_svg__u6ah8yd1re",
    x1: 15.121,
    y1: 10.746,
    x2: 16.309,
    y2: 10.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12B31A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "VideosDark_svg__qgj8vm3z4a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.3958 1.74968 -1.78188 1.42149 9.585 5.078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "VideosDark_svg__ctmb3zk92f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.4105 4.49796 -5.34815 5.24416 5.05 9.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgVideosDark;